import React from "react";
import { motion } from "framer-motion";

/**
 * Ambient animated background — deep navy base with slowly drifting
 * aurora blobs. Sits behind all content (z-0). Purely decorative.
 */
const blobs = [
  {
    className: "bg-accent-400/25 w-[42vw] h-[42vw] -top-[12vw] -left-[8vw]",
    animate: { x: [0, 40, 0], y: [0, 30, 0] },
    duration: 18,
  },
  {
    className: "bg-cyan-400/20 w-[36vw] h-[36vw] top-[8vw] right-[-6vw]",
    animate: { x: [0, -30, 0], y: [0, 40, 0] },
    duration: 22,
  },
  {
    className: "bg-blue-600/20 w-[46vw] h-[46vw] bottom-[-16vw] left-[20vw]",
    animate: { x: [0, 30, 0], y: [0, -30, 0] },
    duration: 26,
  },
];

const AuroraBackground = ({ className = "" }) => {
  return (
    <div className={`aurora-field ${className}`} aria-hidden="true">
      {/* base wash */}
      <div className="absolute inset-0 bg-app-shell" />
      {/* drifting blobs */}
      {blobs.map((b, i) => (
        <motion.div
          key={i}
          className={`aurora-blob ${b.className}`}
          animate={b.animate}
          transition={{
            duration: b.duration,
            repeat: Infinity,
            ease: "easeInOut",
          }}
        />
      ))}
      {/* fine grid + top sheen for depth */}
      <div
        className="absolute inset-0 opacity-[0.4]"
        style={{
          backgroundImage:
            "linear-gradient(180deg, rgba(255,255,255,0.03) 0%, rgba(255,255,255,0) 30%)",
        }}
      />
    </div>
  );
};

export default AuroraBackground;
